/**
 * @generated SignedSource<<62956a8980a18ac8c5b7acc9c3f12fc9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_nativeIssueTable_NativeIssueTable_rankField$data = {
  readonly " $fragmentSpreads": FragmentRefs<"footerRenderer_nativeIssueTable_rankField" | "issueTable_nativeIssueTable_rankField">;
  readonly " $fragmentType": "ui_nativeIssueTable_NativeIssueTable_rankField";
};
export type ui_nativeIssueTable_NativeIssueTable_rankField$key = {
  readonly " $data"?: ui_nativeIssueTable_NativeIssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_nativeIssueTable_NativeIssueTable_rankField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "issueTable_nativeIssueTable_rankField"
    },
    {
      "kind": "FragmentSpread",
      "name": "footerRenderer_nativeIssueTable_rankField"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "eff3157b029509df380c37697d2aad1f";

export default node;
